export function getView(value) {
  switch (value) {
    case 'task_moved':
      return 'TaskMoved'
    case 'task_assigned':
      return 'TaskAssigned'
    case 'task_added':
      return 'TaskAdded'
    default:
      return 'TaskAssigned'
  }
}
